window.initAplayer = function () {
  setTimeout(function () {
    CONFIG.apFixed = new APlayer({
      element: document.getElementById('aplayer-fixed'),
      mutex: true,
      theme: '#97dffd',
      order: 'random',
      lrcType: 3,
      fixed: true,
      volume: 0.5,
      autoplay: true
    });
    $.ajax({
      url: 'https://kainy.cn/api/meting/?server=netease&type=playlist&id=21470989',
      success: function (list) {
        CONFIG.apFixed.list.add(list);
        $(document).one('click', function () { // 手动触发播放
          if (CONFIG.apFixed.audio.paused) {
            CONFIG.apFixed.play()
          }
        })
      }
    });
  }, 234)
}
